'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Back = _interopRequireDefault(require("Layouts/Back"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _DeletePartnerModal = _interopRequireDefault(require("Modals/DeletePartnerModal"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
let app = window.app;
let columns = [{
  id: 'logo',
  label: 'Logo',
  sortable: false
}, {
  id: 'nom',
  label: 'Nom',
  sortable: false
}, {
  id: 'actions',
  label: ''
}];
class PartnersDashboardPage extends _react.Component {
  state = {
    loading: false,
    openDeletePartnerModal: false,
    status_messages: {}
  };
  fetching = {};
  componentDidMount = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchPartner();
  };
  fetchPartner = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (component.fetching['fetchPartner']) {
      component.fetching['fetchPartner'].abort();
    }
    component.setState({
      loading: true
    });
    component.fetching['fetchPartner'] = qwest.post('/partner/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        partners: response.partners
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  openDeletePartnerModal = _ref => {
    let {
      partner_id,
      e
    } = _ref;
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeletePartnerModal: true,
      delete_modal_partner: partner_id,
      delete_modal_trigger: e.target
    });
  };
  closeDeletePartnerModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeletePartnerModal: false,
      delete_modal_partner: undefined,
      delete_modal_trigger: undefined
    });
    component.fetchPartner();
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const list_partners = (state.partners || []).map(function (partner) {
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/contenu/liste-des-partenaires/modifier-partenaire/' + partner.id,
        className: "u-link-only"
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        key: partner._id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, partner.logo[0] ? /*#__PURE__*/_react.default.createElement(_Image.default, {
        className: "c-file-thumbnail__preview c-file-thumbnail__preview--dashboard",
        src: partner.logo[0].url,
        title: "preview" + partner.name,
        alt: "preview" + partner.name
      }) : undefined, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell"
      }, partner.name, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "secondary",
        onClick: e => component.openDeletePartnerModal({
          partner_id: partner._id,
          e: e
        })
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
        color: "secondary"
      }))));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement(_Back.default, _extends({
      page_title: "Partenaires"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-bottom-15 u-text-right"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-5 u-padding-bottom-20 u-padding-left-15 u-padding-right-15"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      href: (0, _Routes.URL)('NewPartnerPage', _Routes.front_urls),
      color: "primary",
      variant: "contained",
      size: "large",
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
    }, "Ajouter un partenaire")), /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "u-margin-bottom-30 u-margin-left-15 u-margin-right-15 u-padding-top-5 u-padding-bottom-20 u-padding-left-15 u-padding-right-15"
    }, /*#__PURE__*/_react.default.createElement(_Table.default, null, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: () => {},
      order: undefined,
      order_by: undefined,
      row_count: (state.partners || []).length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, list_partners)), loader))), /*#__PURE__*/_react.default.createElement(_DeletePartnerModal.default, {
      partner_to_delete: state.delete_modal_partner,
      open: state.openDeletePartnerModal,
      onClose: component.closeDeletePartnerModal,
      delete_modal_trigger: state.delete_modal_trigger
    }));
    return output;
  }
}
exports.default = PartnersDashboardPage;
